import { MARQUEE_ITEMS } from "@/data/site";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee"
      className="overflow-hidden border-y border-ink/10 bg-paper py-4 select-none"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display italic text-xl md:text-2xl text-ink/70">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-clinic" />
          </span>
        ))}
      </div>
    </div>
  );
};
